import React, { useEffect, useState } from "react";
import * as utils from "../../../utils.js";
import _ from "lodash";
import UploadMultipleImageComputerPart from "./UploadMultipleImageComputerPart.jsx";
import UploadMultipleImagePhonePart from "./UploadMultipleImagePhonePart.jsx";

export const MAX_COMPLAINT_UPLOAD_IMAGES = 5;

function getFileDataSize(fileData) {
    return fileData?.imageBlobFile?.size || fileData?.file?.size || fileData?.size;
}

function sameFileSizeExists(file, fileList) {
    return fileList.find((f) => getFileDataSize(f) === getFileDataSize(file));
}

function filterUniqueSelectedImagesDataLocally(selectedImagesDataLocally, selectedImages) {
    return selectedImagesDataLocally.filter((localImage) => !sameFileSizeExists(localImage, selectedImages));
}

export default function UploadMultipleImageQR(props) {
    const {
        appProps,
        selectedImages,
        qrCodeValue,

        imageUrlServiceFn,
        imageUrlServiceFetchData,
        isLoadingImage = false,
        onUploadSuccess,
        alertFn,
        readOnly,
        onRemoved,

        introText = "Upload an image where the defect is clearly visible",
        scanInfoText = "Scan the QR-code using your phones camera app",
        uploadButtonTextPhone = "Upload image",
        orText = "or",
        uploadButtonText,
        secondaryColorCss, // only used for return portal app design settings
    } = props;

    const [selectedImagesDataLocally, setSelectedImagesDataLocally] = useState([]);
    // We filter because there is a moment before the useEffect has taken place where we might have the file both locally and remote. Causing a one frame render issue.
    const filteredSelectedImagesDataLocally = filterUniqueSelectedImagesDataLocally(selectedImagesDataLocally, selectedImages);

    useEffect(() => {
        // Whenever we get new images from remote. We have to remove the local loading placeholding image
        const newState = filterUniqueSelectedImagesDataLocally(selectedImagesDataLocally, selectedImages);
        setSelectedImagesDataLocally(newState);
    }, [selectedImages]);

    function onRemoveClick(imageId) {
        onRemoved(imageId);
    }

    function onRemoveImageDataLocally(imageDataLocally) {
        setSelectedImagesDataLocally(selectedImagesDataLocally?.filter((i) => i.id !== imageDataLocally?.id));
    }

    function onFileInputChange(evt) {
        const files = Array.from(evt.target.files);
        if (files.length > MAX_COMPLAINT_UPLOAD_IMAGES || files.length > MAX_COMPLAINT_UPLOAD_IMAGES - selectedImages?.length) {
            alertFn?.({
                title: "Maximum files reached",
                text: `${MAX_COMPLAINT_UPLOAD_IMAGES} images may be uploaded`,
            });
            return;
        }
        let alreadyUploaded = false;
        const selectedImagesTempArray = [];
        for (const file of files) {
            alreadyUploaded = sameFileSizeExists(file, selectedImagesDataLocally) || sameFileSizeExists(file, selectedImages);
            if (!alreadyUploaded) {
                selectedImagesTempArray.push({
                    file,
                    id: "input-upload-" + _.uniqueId(),
                });
            }
        }

        if (selectedImagesTempArray?.length) {
            setSelectedImagesDataLocally(selectedImagesDataLocally.concat(selectedImagesTempArray));
        }

        if (alreadyUploaded) {
            alertFn?.({
                title: "Image already uploaded",
                text: "One or more of the images were already uploaded",
            });
        }
    }

    const isPhone =
        appProps?.forcePhoneView ||
        utils.isPhone({
            windowObject: window,
            userAgent: window.navigator.userAgent,
        });

    const multipleImageQrProps = {
        qrCodeValue,
        introText,
        scanInfoText,
        uploadButtonTextPhone,
        orText,
        isLoadingImage,
        secondaryColorCss,
        alertFn,
        readOnly,
        onUploadSuccess,
        uploadButtonText,
        onRemoveClick,
        onRemoveImageDataLocally,
        onFileInputChange,
        imageUrlServiceFn,
        imageUrlServiceFetchData,
        selectedImages,
        selectedImagesDataLocally: filteredSelectedImagesDataLocally,
    };

    if (isPhone) {
        return <UploadMultipleImagePhonePart appProps={appProps} multipleImageQrProps={multipleImageQrProps} />;
    } else {
        return <UploadMultipleImageComputerPart appProps={appProps} multipleImageQrProps={multipleImageQrProps} />;
    }
}
